<template>
  <v-app id="app-wrapper">
    <div v-if="isNotLandingPage" id="nav-bar" class="dontPrint">
      <!-- Header -->
      <v-navigation-drawer v-model="drawer" temporary app>
        <v-list :key="listKey" dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="mennuHeader">
                {{ $t("logo") }}
              </v-list-item-title>
              <hr />
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/kalkulator">
            <v-list-item-content>
              <v-list-item-title>
                <i class="fad fa-calculator fa-lg"></i>
                {{ $t("calculator") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isAuthenticated" to="/pacienti">
            <v-list-item-content>
              <v-list-item-title>
                <i class="fad fa-notes-medical fa-lg"></i>
                {{ $t("patienst") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/co-je-easi">
            <v-list-item-content>
              <v-list-item-title>
                <i class="fad fa-question fa-lg"></i>
                {{ $t("what_is_easi") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/kontakt">
            <v-list-item-content>
              <v-list-item-title>
                <i class="fas fa-phone-alt fa-lg"></i>
                {{ $t("contact") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="!isAuthenticated"
            class="mobile-login"
            to="/prihlaseni"
          >
            <v-list-item-content>
              <v-list-item-title>
                <i class="fas fa-sign-in-alt fa-lg"></i>
                {{ $t("login_title") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="!isAuthenticated"
            class="mobile-login"
            to="/registrace"
          >
            <v-list-item-content>
              <v-list-item-title>
                <i class="fas fa-user-plus fa-lg"></i>
                {{ $t("registration") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <!-- App bar -->
      <v-app-bar app color="#324c8d" dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title>
          <router-link to="/kalkulator">{{ $t("logo") }}</router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isAuthenticated"
          text
          to="/prihlaseni"
          class="mr-2 pc-login"
          >{{ $t("login_title") }}</v-btn
        >
        <v-btn v-if="!isAuthenticated" text to="/registrace" class="pc-login">{{
          $t("registration")
        }}</v-btn>
        <!-- <v-btn text @click="onLocaleChange" class="mr-4">{{ language }}</v-btn> -->
        <div v-if="isAuthenticated" id="user-menu">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-avatar size="30" color="white">
                  <v-icon color="#324c8d">mdi-account</v-icon>
                </v-avatar>
                <v-icon>mdi-chevron-down</v-icon>
              </div>
            </template>
            <v-list id="menu-list">
              <v-list-item @click="onLogoutClick">
                <v-list-item-title>
                  <i class="far fa-sign-out-alt mr-2"></i>
                  Odhlásit
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-app-bar>
    </div>
    <router-view />

    <v-dialog v-model="confirmationDiaolog" persistent max-width="500">
      <v-card id="confirmation-dialog">
        <div class="dialog-header">
          <h2>Vítejte v aplikaci EASI score</h2>
        </div>
        <p>{{ $t("confirmation_dialog_text") }}</p>
        <p>{{ $t("confirmation_dialog_text1") }}</p>

        <v-checkbox
          v-model="expertiseConfirmation"
          :label="$t('expertise_confirmation')"
          color="#324c8d"
          :error-messages="expertiseConfirmationValidation"
          hide-details="auto"
        />
        <v-checkbox
          v-model="termsConfirmation"
          color="#324c8d"
          :error-messages="termsConfirmationValidation"
          hide-details="auto"
        >
          <template v-slot:label>
            <span>
              Používání těchto webových stránek podléhá podmínkám, které jsou k
              dispozici v plném znění
              <a
                href="https://easi-score.b-cdn.net/EASIscore_Podmínky_užití_1.0%20(1).pdf"
                target="_blank"
                @click.stop
                rel="noopener noreferrer"
                >zde</a
              >. Vstupem na stránky s těmito podmínkami souhlasím. Beru na
              vědomí, že k ukládání nastavení a správnému fungování webové
              stránky využívají soubory cookies. Používáním webu k využití
              těchto souborů uděluji souhlas.</span
            >
          </template>
        </v-checkbox>
        <v-btn id="enter-button" @click="onEnterButton" color="#324c8d" dark>
          {{ $t("enter_button") }}
        </v-btn>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from "vue";
import { clearStorage } from "@/utils/localStorageUtils";

export default Vue.extend({
  name: "App",
  data() {
    return {
      drawer: null,
      listKey: 0,
      confirmationDiaolog: true,
      expertiseConfirmation: false,
      termsConfirmation: false,
      expertiseConfirmationValidation: null,
      termsConfirmationValidation: null,
    };
  },
  created() {
    if (!localStorage.expertiseConfirmation) {
      localStorage.setItem("expertiseConfirmation", false);
    } else {
      this.expertiseConfirmation = localStorage.expertiseConfirmation == "true";
      this.confirmationDiaolog = !this.expertiseConfirmation;
    }
  },
  computed: {
    isNotLandingPage() {
      return this.$route.name !== "landing-page";
    },
    language() {
      return this.$i18n.locale === "cs" ? "Čeština" : "Slovenština";
    },
    isAuthenticated() {
      return this.$store.getters.isUserAuthenticated;
    },
  },
  watch: {
    isAuthenticated() {
      this.listKey++;
    },
    expertiseConfirmation() {
      this.expertiseConfirmation
        ? (this.expertiseConfirmationValidation = null)
        : (this.expertiseConfirmationValidation = this.$t(
            "expertise_confirmation_error"
          ));
    },
    termsConfirmation() {
      this.termsConfirmation
        ? this.termsConfirmationValidation = null
        : this.termsConfirmationValidation =
            "Je nutné souhlasit s podmínkami webu"
    },
  },
  methods: {
    onLocaleChange() {
      this.$i18n.locale = this.$i18n.locale === "cs" ? "sk" : "cs";
      localStorage.setItem("userLocale", this.$i18n.locale);
    },
    onLogoutClick() {
      this.$store.commit("logout");
      clearStorage();
      this.$router.push({ name: "prihlaseni" });
    },
    onEnterButton() {
      if (
        this.expertiseConfirmation === false &&
        this.termsConfirmation === false
      ) {
        this.expertiseConfirmationValidation = this.$t(
          "expertise_confirmation_error"
        );
        this.termsConfirmationValidation =
          "Je nutné souhlasit s podmínkami webu";
        return;
      }
      if (this.expertiseConfirmation === false) {
        this.expertiseConfirmationValidation = this.$t(
          "expertise_confirmation_error"
        );
        return;
      }

      if (this.termsConfirmation === false) {
        this.termsConfirmationValidation =
          "Je nutné souhlasit s podmínkami webu";
        return;
      }

      localStorage.expertiseConfirmation = this.expertiseConfirmation;
      this.confirmationDiaolog = !this.expertiseConfirmation;
    },
  },
});
</script>
<style lang="scss">
#app-wrapper {
  //Menu styles
  #nav-bar {
    margin-bottom: 7rem;
  }

  .v-navigation-drawer {
    z-index: 500;
  }

  .v-overlay {
    z-index: 100;
  }

  .v-menu__content--fixed {
    left: auto !important;
    right: 30px !important;
    margin-top: 0.5rem;
    z-index: 1000 !important;

    .v-list-item {
      cursor: pointer;
    }
  }

  #user-menu {
    margin-right: 1rem;
    cursor: pointer;

    .v-avatar {
      margin-right: 0.5rem;
    }
  }

  #menu-list {
    display: flex;
    min-width: 8rem;
  }

  .fa-lg {
    margin-right: 1em;
    color: #324c8d;
  }

  .v-list--dense .v-list-item .v-list-item__title {
    font-size: 1rem;
  }

  .v-list-item__content {
    padding: 1rem 0;
  }

  .v-list--dense .v-list-item .v-list-item__title.mennuHeader {
    padding: 1rem 0;
    font-size: 1.5rem;
    color: #324c8d;
  }

  .v-toolbar__title {
    a {
      color: white;
      text-decoration: none;
    }
  }

  // .v-overlay {
  //   z-index: 2000!important
  // }

  .v-dialog__content {
    z-index: 2000 !important;
  }

  .v-dialog > .v-card > .v-card__title {
    word-break: break-word;
  }

  #confirmation-dialog {
    padding: 2rem;

    h2 {
      margin-bottom: 1rem;
    }

    .theme--light.v-label {
      color: rgb(53, 53, 53);
    }

    #enter-button {
      width: 100%;
      margin-top: 2rem;
    }
  }
  @media only screen and (min-width: 200px) and (max-width: 500px) {
    #nav-bar {
      margin-bottom: 4rem;
    }

    .pc-login {
      display: none;
    }

    .mobile-login {
      display: block;
    }

    h2 {
      text-align: center;
      margin-bottom: 1em;
    }

    #evaluationScaleTable {
      font-size: 12px;
    }
    #calculatorBox {
      padding: 1.5em 0 0 !important;
      margin-bottom: 1.5rem;
    }
    .v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes)
      .v-slide-group__prev {
      display: none !important;
    }
  }

  @media only screen and (min-width: 500px) {
    .pc-login {
      display: flex;
    }
    .mobile-login {
      display: none;
    }
  }
}
@media print {
  @page {
    size: landscape;
    filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=3);
  }

  h2,
  p {
    margin: 0;
  }
  #printPDF {
    display: block !important;
  }
  label {
    color: rgb(135, 135, 204);
  }
  .dontPrint {
    display: none;
  }
  .v-card {
    box-shadow: none !important;
    border: 1px solid gainsboro !important;
    border-radius: 5px !important;
  }
  .container {
    padding: 0 !important;
    box-shadow: none !important;
  }
  #patientInfoBox {
    padding: 0;
    box-shadow: none !important;
    margin: 0 !important;
  }
  .v-content {
    margin: 0 !important;
    padding: 0 !important;
  }
  body {
    font-size: 12px;
    margin-top: 0;
  }
  .inactive {
    color: gray !important;
  }
  .active {
    border: 1px solid gray !important;
    border-radius: 5px;
    color: rgb(53, 53, 53) !important;
  }
  #tableFooter {
    background: transparent !important;
  }
  table {
    border: 1px solid gainsboro;
    border-radius: 5px;
  }
}
.v-application--wrap {
  background-color: white;
}
h2 {
  color: #324c8d;
}
.v-content {
  margin: 0em !important;
}
</style>
